import owd from 'owd/owd';

export default class Infographic extends owd.Component {
	init() {
        if(!this.$element.find('svg').length) {
            this.infographic = this.$element.find('img');
            this.infographicWrapper = this.$element.find('div');
            this.infographicWidth = Number(this.infographic.data('width'));
            //console.log(this.infographicWrapper);
            this.initWrapper();
        } else {
            this.infographicSVG = this.$element.find('svg');
            this.infographicWidth = this.infographicSVG.attr('width');
            this.infographicHeight = this.infographicSVG.attr('height');
            
            this.initDimensions();
        }
	}
    
    initDimensions() {
        this.infographicSVG.css({
            width: this.infographicWidth,
            height: this.infographicHeight
        })
    }
    
    initWrapper() {
        this.infographicWrapper.css({
            width: this.infographicWidth + 'px' 
        });
    }

    destroy() {
        super.destroy();
    }
}

owd.registerComponent('infographic', {
	component: Infographic
});
